// extracted by mini-css-extract-plugin
module.exports = {"modal":"ModalNext_modal__2NwBy","modalLayout":"ModalNext_modalLayout__3PziS","overlay":"ModalNext_overlay__32U1i"};